// // utils.js
// export function validateInputs(context, inputs, validations) {
    
//     for (const [field, rules] of Object.entries(validations)) {
//         const value = field.split('.').reduce((o, i) => o[i], inputs);

//         // Si el campo es requerido y está vacío
//         if (rules.required && (!value || value === '')) {
//             context.$toastr.e(context.$t(rules.message || `${field} is required.`));
//             return false;
//         }

//         // Si se especifica una longitud mínima y el valor es más corto
//         if (rules.minLength && value.length < rules.minLength) {
//             context.$toastr.e(context.$t(rules.message || `${field} must be at least ${rules.minLength} characters long.`));
//             return false;
//         }

//         // Si se especifica una longitud máxima y el valor es más largo
//         if (rules.maxLength && value.length > rules.maxLength) {
//             context.$toastr.e(context.$t(rules.message || `${field} must be no longer than ${rules.maxLength} characters.`));
//             return false;
//         }

//         // Validación para asegurarse de que el valor sea numérico
//         if (rules.isNumber && isNaN(value)) {
//             context.$toastr.e(context.$t(rules.message || `${field} must be a number.`));
//             return false;
//         }
//     }
//     return true;
// }
// utils.js

export function validateInputs(context, inputs, validations) {

    for (const [field, rules] of Object.entries(validations)) {
        const value = field.split('.').reduce((o, i) => o[i], inputs);

        // Si el campo es requerido y está vacío
        if (rules.required && (!value || value === '')) {
            context.$toastr.e(context.$t(rules.message || `${field} is required.`));
            return false;
        }

        // Si el campo tiene espacios en blanco al inicio o final
        if (rules.noWhitespace && value.trim() !== value) {
            context.$toastr.e(context.$t(rules.message || `${field} should not contain leading or trailing spaces.`));
            return false;
        }

        // Si se especifica una longitud mínima y el valor es más corto
        if (rules.minLength && value.length < rules.minLength) {
            context.$toastr.e(context.$t(rules.message || `${field} must be at least ${rules.minLength} characters long.`));
            return false;
        }

        // Si se especifica una longitud máxima y el valor es más largo
        if (rules.maxLength && value.length > rules.maxLength) {
            context.$toastr.e(context.$t(rules.message || `${field} must be no longer than ${rules.maxLength} characters.`));
            return false;
        }

        // Validación para asegurarse de que el valor sea numérico
        if (rules.isNumber && isNaN(value)) {
            context.$toastr.e(context.$t(rules.message || `${field} must be a number.`));
            return false;
        }
    }
    return true;
}
